import React, { useRef } from "react";
import OptionButtons from "../../../../../../components/buttons/optionsBtn";
import { extractFileId, QUESTION_TYPES } from "../../../../../../utils/data";
import { getAssessmentData } from "../../../../../../functions/localStorage";
import {
  removeImage,
  uploadImageApi,
} from "../../../../../../api/apis/assesments";
import Uploader from "../uploader";
import { parseIfStringify, removeSpaceAndUppercase } from "../../../../../../functions/common";

const YesNoUpload = ({
  data,
  handleAnswer,
  answers,
  uploadLoading,
  setUploadLoading,
  currentIndex,
  notApplicable,
  responseType
}) => {
  const answer1 =
    answers?.[data?.refCode]?.split(" + ")?.[0]?.replace("", "") ?? "";
  const textValue =
    answers?.[data?.refCode]?.split(" + ")?.[1]?.replace("", "") ?? "";
  const inputRef = useRef();
  const { locationId, assessmentId } = getAssessmentData() ?? {};
  const images = parseIfStringify(
    answers?.[data?.refCode]?.split(" + ")?.[2]?.replace("", "") ?? []
  );
  console.log("Ues no")
  const handleFileUpload = async (file) => {
    if (file) {
      setUploadLoading(true);
      const imageData = await uploadImageApi(
        {
          file: file,
          ref: data?.refCode,
        },
        locationId,
        assessmentId
      );
      setUploadLoading(false);
      const fileData = {
        fileName: imageData?.data?.fileName,
        viewLink: imageData?.data?.viewLink,
      };
      const updatedImages = [...images, fileData];
      const formattedAnswer = `${answer1} + ${
        textValue ?? ""
      } + ${JSON.stringify(updatedImages)}`;
      handleAnswer(formattedAnswer);
      inputRef.current.value = "";
    }
  };

  const handleDelete = (item) => {
    const driveId = extractFileId(item?.viewLink);
    const updatedImages = images?.filter((v) => v?.viewLink !== item?.viewLink);
    handleAnswer(
      `${answer1} + ${textValue ?? ""} + ${JSON.stringify(updatedImages)}`
    );
    if (driveId) removeImage(driveId);
  };

  const handleResponseChange = (label) => {
    handleAnswer(
      `${label} + ${textValue ?? ""}${
        data?.supportingDoc ? ` + ${JSON.stringify(images)}` : ""
      }`
    );
  };

  const handleAdditionalTextChange = (value) => {
    handleAnswer(`${answer1} + ${value ?? ""}${
        data?.supportingDoc ? ` + ${JSON.stringify(images)}` : ""
      }`);
  };

  return (
    <div className="yes__upload">
      <div className="yes__upload__options">
        <OptionButtons
          selected={answer1}
          onSelect={(label) => {
            return handleResponseChange(label);
          }}
          notApplicable={notApplicable}
          responseType={responseType}
        />
      </div>
      {data?.prompt ? (
        <div className="yes__text__comment mt-4">
          <p>{data?.prompt}</p>
          <textarea
            rows="5"
            value={textValue}
            onChange={(e) => {
              const updatedText = e.target.value;
              handleAdditionalTextChange(updatedText);
            }}
            required={true}
          ></textarea>
        </div>
      ) : (
        ""
      )}
      {data?.supportingDoc || data?.responseType === "YN+AL-Text" || removeSpaceAndUppercase(data?.responseType) === removeSpaceAndUppercase(QUESTION_TYPES.YESNONOTAPPLICABLE) ? (
        <Uploader
          inputRef={inputRef}
          handleFileUpload={handleFileUpload}
          handleUpload={handleFileUpload}
          handleDelete={handleDelete}
          uploadLoading={uploadLoading}
          data={data}
          images={images}
          currentIndex={currentIndex}
        />
      ) : null}
    </div>
  );
};

export default YesNoUpload;
